<template>
    <div>
        <div class="calendars-wrapper">
            <div class="week-numbers">
                <div class="week-header">
                    <div class="week-title px-3">Week</div>
                </div>
                <div class="week" v-for="(week, weekIndex) in weeks" :key="weekIndex">
                    <span class="week-number pt-1">{{ week.number}}</span>
                </div>
            </div>
            <div class="calendar calendar-grow">
                <div class="calendar-week">
                    <div class="calendar-day" v-for="(calendarDay, calendarDayIndex) in calendarDays" :key="'calendarDay' + calendarDayIndex">{{ calendarDay }}</div>
                </div>
                <div class="week" v-for="(week, weekIndex) in weeks" :key="weekIndex">
                    <day-component v-for="(day, dayIndex) in week" :key="dayIndex" :day="day"></day-component>
                    <blocks-component classe="event-block" :blocks="getBlocksForWeek(week)" @clicked="handleModal" :week="week"></blocks-component>
                </div>
            </div>
        </div>
        <Modal
            v-if="selectedObject"
            :title="selectedObject.block.name"
            :range="rangeSelectedBlock"
            id="selectedModal"
            :show="selectedModal"
            @close="closeSelectedModal"
            v-click-outside="closeClickOutside"
            :left="selectedObject.position.left"
            :top="selectedObject.position.top">
            <p class="text-muted mb-0">{{ selectedObject.block.description }}<br>{{ selectedObject.block.reference}}</p>
        </Modal>
        <Modal
            v-if="moreObject"
            :title="moreDay"
            id="moreModal"
            :show="moreModal"
            @close="closeAllModals"
            v-click-outside="closeClickOutside"
            :left="moreObject.position.left"
            :top="moreObject.position.top">
            <blocks-component classe="modal-block" :blocks="moreObject.block.dayBlocks" @clicked="handleMoreModal"></blocks-component>
        </Modal>
    </div>
</template>

<script>
import DayComponent from './Day.vue';
import BlocksComponent from './Blocks.vue';
import Modal from "./Modal.vue";
import ClickOutside from '../../directives/clickOutside.js';

export default {
    components: {
        DayComponent,
        BlocksComponent,
        Modal,
    },
    directives: {
        ClickOutside,
    },
    props: {
		selectedDate: { type: Date, required: true },
        events: { type: Array, required:true}
    },
    computed: {
        moreDay() {
            return this.moreObject.day.date.toLocaleDateString('en-NL', {weekday: 'short', day: 'numeric' });
        },
        rangeSelectedBlock() {
            if(this.selectedObject.block.text_color == 'text-white') {

                return "<i class='fa fa-circle-thin'></i> " +  this.selectedObject.block.start_date + " - "  + (this.selectedObject.block.end_date ? this.selectedObject.block.end_date : "unknown");
            }

            return "<i class='fa fa-circle " + this.selectedObject.block.text_color + "'></i> " +  this.selectedObject.block.start_date + " - "  + (this.selectedObject.block.end_date ? this.selectedObject.block.end_date : "unknown");
        }
    },
    data() {
        return {
            calendarDays: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            weeks: [],
            dayWidth: 100/7,
            selectedModal: false,
            moreModal: false,
            selectedObject: null,
            moreObject: null,
        }
    },
    created() {
        this.calculateWeeksAndDays();
    },
    mounted() {
        window.addEventListener('resize', this.closeAllModals);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.closeAllModals);
    },
    watch: {
        selectedDate(newValue) {
            this.calculateWeeksAndDays();
        },
    },
    methods: {
        calculateWeeksAndDays() {
            let firstDay = new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth());
            let lastDay = new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth() + 1, 0);

            let firstDayOfWeek = (firstDay.getDay() + 6) % 7;//0  is sunday, ... 6 saturday
            let lastDayOfWeek = (lastDay.getDay() + 6) % 7;//(xx + 6) % 7 is a fix to start from monday

            // Calculate the start date (Monday of the first week)
            let startDate = new Date(firstDay);
            startDate.setDate(firstDay.getDate() - firstDayOfWeek);

            // Calculate the end date (Sunday of the last week)
            let endDate = new Date(lastDay);
            endDate.setDate(lastDay.getDate() + (6 - lastDayOfWeek));

            this.weeks = [];
            let currentDate = new Date(startDate);

            while (currentDate <= endDate) {
                let week = [];
                let weekStartDate = new Date(currentDate);

                for (let i = 0; i < 7; i++)
                {
                    let day = {};
                    day.date = new Date(currentDate);
                    day.number = currentDate.getDate();
                    day.position = (currentDate.getDay() + 6) % 7;
                    day.other = (currentDate < firstDay|| currentDate > lastDay) ? true : false;
                    day.selected = (currentDate.getDate() == this.selectedDate.getDate() && currentDate.getMonth() == this.selectedDate.getMonth()) ? true: false;

                    week.push(day);

                    currentDate.setDate(day.number + 1);
                }

                week.number = this.getWeekNumber(weekStartDate);

                this.weeks.push(week);
            }
        },
        getWeekNumber(date) {
            const currentDate = new Date(date.getTime());
            currentDate.setHours(0, 0, 0, 0);
            currentDate.setDate(currentDate.getDate() + 3 - (currentDate.getDay() + 6) % 7);// sets the current date to thursday
            const week1 = new Date(currentDate.getFullYear(), 0, 4);  // January 4 is always in week 1

            return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);// Adjust to Thursday in week 1 and count number of weeks from date to week1.
        },
        getBlocksForWeek(week) {
            const weekStart = week[0].date;
            const weekEnd = week[6].date;
            let blocks = [];

            this.events.forEach(event => {
                const eventStart = this.dateFromFormat(event.start_date);
                const eventEnd = event.end_date != '' ? this.dateFromFormat(event.end_date) : eventStart;

                if (eventStart <= weekEnd && eventEnd >= weekStart) {
                    const startDayOfWeek = Math.max((eventStart - weekStart) / (1000 * 60 * 60 * 24), 0);//the diff is in ms, so we have to convert it back in days
                    const endDayOfWeek = Math.min((eventEnd - weekStart) / (1000 * 60 * 60 * 24), 6);

                    blocks.push({
                        reference: event.ad.reference,
                        name: event.ad.name,
                        startDayOfWeek: startDayOfWeek,
                        endDayOfWeek: endDayOfWeek,
                        left: startDayOfWeek ,
                        width: endDayOfWeek - startDayOfWeek + 1,
                        bg_color: 'bg-' + event.color,
                        text_color: 'text-' + event.color,
                        description: event.description,
                        start_date:  event.start_date,
                        end_date:  event.end_date,
                        top: '',
                        show: true,
                        more: false,
                        dayBlocks: [],
                    });
                }
            });

            blocks = this.sortBlocks(blocks);
            blocks = this.caculateTops(blocks);
            blocks = this.calculateMore(blocks, week);

            return blocks;
        },
        sortBlocks(blocks) {
            return blocks.sort(function(a, b) {
                if (a.left !== b.left) {

                    return a.left - b.left;
                }

                return b.width - a.width;
            });
        },
        caculateTops(blocks) {
            let blockSlots = [];

            blocks.forEach(block => {
                const width = block.width;
                const left = block.left;

                let top = 0;
                let overlapFound = true;

                while (overlapFound) {
                    overlapFound = false;

                    for (let slot of blockSlots) {
                        if (slot.top === top && (
                            (left >= slot.left && left < slot.left + slot.width) ||
                            (left + width > slot.left && left + width <= slot.left + slot.width) ||
                            (left <= slot.left && left + width >= slot.left + slot.width)
                        )) {
                            overlapFound = true;
                            top++;
                            break;
                        }
                    }
                }

                blockSlots.push({ left, width, top });
                block.top = top;

                if (block.top > 2) {
                    block.show = false;
                }
            });

            return blocks;
        },
        calculateMore(blocks) {
            var eventsByDay = {};

            blocks.forEach((block, index) => {
                for (let day = block.startDayOfWeek; day < block.endDayOfWeek + 1; day++) {
                    if (! eventsByDay[day]) {
                        eventsByDay[day] = [];
                        eventsByDay[day]['blocks'] = [];
                    }
                    eventsByDay[day]['blocks'].push(block);
                }
            });

            Object.keys(eventsByDay).forEach(day => {

                const hiddenBlocksCount = eventsByDay[day]['blocks'].filter(block => block.show === false).length;
                const hasHiddenBlocks = eventsByDay[day]['blocks'].some(block => block.show === false);

                if(hasHiddenBlocks) {
                    blocks.push({
                        reference: '',
                        name: hiddenBlocksCount + ' more',
                        startDayOfWeek: day,
                        endDayOfWeek: day,
                        left: day,
                        width: 1,
                        bg_color: '',
                        text_color: '',
                        description: '',
                        start_date: '',
                        end_date: '',
                        top: 3, // position it below the 3rd block
                        show: true,
                        more: true,
                        dayBlocks: eventsByDay[day]['blocks'],
                    });
                }
            });

            return blocks;
        },
        handleMoreModal(event, value) {
            event.stopPropagation();

            this.selectedObject = value;
            this.selectedModal = true;
        },
        handleModal(event, value) {
            event.stopPropagation();
            this.closeAllModals();

            if(value.block.more) {
                this.moreObject = value;
                this.moreModal = true;
            } else {
                this.selectedObject = value;
                this.selectedModal = true;
            }
        },
        closeSelectedModal() {
            this.selectedObject = null;
            this.selectedModal = false;
        },
        closeAllModals() {
            this.moreModal = false;
            this.moreObject = null;

            this.selectedModal = false;
            this.selectedObject = null;
        },
        closeClickOutside(event) {
            if (event.target.classList.contains('fa') || event.target.classList.contains('btn') || event.target.classList.contains('custom-select')) {
                this.closeAllModals();

                return;
            }

            if(this.selectedModal) {
                this.closeSelectedModal();

                return;
            }

            this.closeAllModals();
        },
        dateFromFormat($date) {
            const[day, month, year] = $date.split('/').map(Number);

            return new Date(year, month - 1, day);
        },
    },
}
</script>

<style scoped>
.calendars-wrapper {
    display: flex;
    flex-direction: row;
    width: 100%;
}
.calendar, .week-numbers {
    display: flex;
    flex-direction: column;
    border-left: 1px solid #ddd;
    border-top: 1px solid #ddd;
}
.week-numbers {
    flex-shrink: 0;
    width: auto;
}
.calendar-grow {
    flex-grow: 1;
}
.calendar-week, .week-header {
    display: flex;
    position: relative;
    height: 40px;
}
.calendar-day, .week-title {
    display: flex;
    flex: 1;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
}
.week-title {
    border-right: none;
}
.week {
    display: flex;
    position: relative;
    height: 130px;
    overflow: hidden;
}
.week-number {
    flex: 1;
    text-align: center;
    border-bottom: 1px solid #ddd;
}
.week-number span {
    display: inline-block;
}
</style>